<template>
  <div class="card-produto-repeticao-inicio">
    <g-card :temCabecalho="false">
      <div class="produto-repeticao-inicio">
        <img class="imagem-cabecalho" src="@/assets/imgs/icone_orc_produto.svg"/>

        <div class="titulo-inicio-fluxos"> Orçamento - Produto Repetição </div>
        <div class="subtitulo-fluxos"> Selecione a empresa, o representante e o cliente </div>

        <g-form>
          <div class="container-inputs espacamento-inicio-fluxos">
            <div class="produto-novo-cliente input">
              <label class="titulo-conteudo-filtros"> Unidade</label>
              <PDropDown
              v-model="EmpresaSelecionada"
              :options="EmpresaArray"
              optionLabel="nome"
              :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
              optionValue="id"
              placeholder="Selecione a Unidade"
              :filter="true"
              @change="zerarcampos"
              />
            </div>

            <div class="produto-novo-unidade input">
              <label class="titulo-conteudo-filtros unidade"> Cliente </label>
              <!-- <PDropDown
                class="p-dropdown clinte"
                v-model="ClienteSelecionado"
                :options="ClientesArray"
                :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                optionLabel="nomeFantasia"
                placeholder="Selecione o Cliente"
                optionValue="id"
                :filter="true"
                @filter="buscarClientes($event.value)"
              >
                <template #option="slotProps">
                  <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                </template>
              </PDropDown> -->

              <cliente-dropdown
              class="p-dropdown cliente"
              v-model="ClienteSelecionado"
              :empresaId="EmpresaSelecionada"
              :representanteId="RepresentanteSelecionado"
              />
            </div>

            <div class="produto-novo-representante input">
              <label class="titulo-conteudo-filtros"> Representante </label>
              <PDropDown
              v-model="RepresentanteSelecionado"
              :options="RepresentantesArray"
              optionLabel="codigoNomeRepresentante"
              optionValue="representanteId"
              @filter="buscarRepresentante($event.value)"
              :filter="true"
              placeholder="Selecione o Representante"
              @click="procurarRepresentante"
              />
            </div>
          </div>
        </g-form>

        <div class="alinha-button-fluxo">
          <div class="button-fluxo">
            <g-button
            tipo="amarelo" 
            negritoTexto 
            altura="35px"
            largura="100%"
            @click="continuar"
            >
              <div v-if="escritobotao"> CONTINUAR </div>
              <div v-if="!escritobotao" class="pi pi-spin pi-spinner"></div>
            </g-button>
          </div>
        </div>
      </div>
    </g-card>
  </div>
</template>

<script>
import ProdutoRepeticaoInicio from "./ProdutoRepeticaoInicio.js";
export default ProdutoRepeticaoInicio;
</script>

<style scoped>
.container-inputs {
  margin-bottom: 50px;
}

.input {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.2rem;
}

@media (min-width: 310px) {
  .produto-repeticao-inicio {
    margin-top: 60px;
  }
}

@media (min-width: 600px) {
  .container-inputs {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    gap: 10px 20px;
  }

  .produto-novo-cliente {
    grid-area: 1 / 1 / 2 / 3;
  }
  .produto-novo-unidade {
    grid-area: 2 / 2 / 3 / 3;
  }
  .produto-novo-representante {
    grid-area: 2 / 1 / 3 / 2;
  }
}

@media (min-width: 801px) {

}

@media (min-width: 1025px) {
  .produto-repeticao-inicio {
    margin-top: 80px;
  }
}

@media (min-width: 1281px) {

}
</style>
